import { Organisation } from '@models/organisation';
import { createDynamicQueryBody } from '@utils';
import { QueryResult, useFetch } from '../common';

const ENDPOINT_URL = 'organisation';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const useGetOrganization = (id?: string) => {
  return useFetch<Organisation>(`${ENDPOINT_URL}/${id}`, { enabled: !!id });
};

export function useGetOrganizations() {
  const dynamicQueryBody = createDynamicQueryBody(['Bezeichnung']);

  const result = useFetch<QueryResult<Organisation[]>>(
    `${ENDPOINT_URL}/DynamicQuery`,
    { method: 'POST', body: dynamicQueryBody },
  );
  return { ...result, result: result.result?.data ?? null };
}
